import type { TranslationObj } from "$/utils/lang"

enum EProductTypeConfigTitle {
    ShowCoachingPlan = "show-coaching-plan",
    ShowPostSessionPopup = "show-post-session-popup",
    AllowModules = "allow-modules"
}

enum EProductTypeInternalName {
    Wiser = "wiser",
    WiserDemo = "wiser-demo",
    SpotCoaching = "spot-coaching",
    LeadershipCoaching = "leadership-coaching",
    ExecutiveCoaching = "executive-coaching"
}

interface IProductTypeConfigModel {
    isActive: boolean
    title: EProductTypeConfigTitle
}

interface IProductTypeModel {
    configs: IProductTypeConfigModel[]
    logo: string | null
    coachingSessionsPageName: string
    coachingSessionsPageNameInPreferredLang: string
    supportEmail: string
    supportTeamName: string
    supportTeamNameInPreferredLang: string
    productTypeTitle: TranslationObj
    productTypeTitleInPreferredLang: string
    internalName: EProductTypeInternalName
}

export { EProductTypeConfigTitle, EProductTypeInternalName }
export type { IProductTypeConfigModel, IProductTypeModel }
